import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsCodacyComponent } from './simple-icons-codacy.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsCodacyComponent ],
    exports:      [ SimpleIconsCodacyComponent ],
    bootstrap:    []
})
export class SimpleIconsCodacyModule {}
